import clone from 'clone'

export const batchScheduleMixin = {
  data() {
    return {
      batchForm: {
        jobId: null,
        jobName: '',
        jobSchedule: null,
        jobMode: 'ONCE',
        jobScheduleTime: '',
        actionName: '',
        jobTimeKey: null,
        jobCron: null
      },
      defaultJobNames: [
        { label: 'Claim Pending Registration Notification', value: 'qrtzClaimPendingRegistrationNotif' },
        { label: 'Generate XOL', value: 'qrtzXOLRecoveryGenerate' },
        // { label: 'Batch GL Update', value: 'qrtzClaimRiRcvry' },
        { label: 'Batch Match Transaction', value: 'qrtzMatchTrans' },
        { label: 'Batch GL Update', value: 'qrtzBatchGLUpdate' },
        { label: 'Batch Policy Release', value: 'qrtzPolicyRelease' },
        { label: 'Process Renewal', value: 'qrtzProcessRenewal' },
        { label: 'Batch RI Outward Release', value: 'qrtzBatchRIOutRelease' },
        { label: 'Batch UPR Annual and GL', value: 'qrtzUPRAnnualAndGL' }
      ]
    }
  },
  computed: {
    commonMenu() {
      return this.$store.state.commons.menu
    }
  },
  methods: {
    async processRequest(oForm) {
      this.resetMessages()
      const apiURI = this.commonMenu.batchSchedule
      if (apiURI) {
        try {
          let target = clone(this.batchForm)
          let source = clone(oForm)
          let returnedTarget = Object.assign(target, source)
          const result = await this.$http.post(apiURI, returnedTarget)
          const { data } = result
          if (data) {
            if (this.batchFormField.actionName === 'schedule') {
              this.$toast.success('Job successfully scheduled.')
            }
            this.showAddSchedule = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  }
}
